/** Clés paiement automatique partenaire (aligné moteur réservation hôtel). */
const AUTO_PAYMENT_KEYS = new Set([
  'debiteur',
  'deposit',
  'totalite_en_ligne',
  'total_marge',
  'Débiteur',
  'Deposit',
  'Totalité en ligne',
  'Total-Marge',
]);

export function isHotelStylePaymentMethods(obj) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false;
  return Object.keys(obj).some((k) => AUTO_PAYMENT_KEYS.has(k) || /^\d+$/.test(String(k)));
}

/**
 * Sérialise le paiement pour `transfert_reservation.payment_method` (JSON).
 * @param {{ payment_bundle?: object|null, payment_methods?: object|null }} draft
 */
export function serializeTransferPaymentMethod(draft) {
  const methods = draft?.payment_methods;
  if (methods && typeof methods === 'object' && Object.keys(methods).length > 0) {
    return JSON.stringify(methods);
  }
  const bundle = draft?.payment_bundle;
  if (!bundle || bundle.methodId == null) return 'Manuel';
  try {
    const { methodId, amount, fields, methodName } = bundle;
    return JSON.stringify({
      methodId,
      amount: Number(amount) || 0,
      fields: fields && typeof fields === 'object' ? fields : {},
      ...(methodName != null && String(methodName).trim()
        ? { methodName: String(methodName).trim() }
        : {}),
    });
  } catch {
    return 'Manuel';
  }
}

/**
 * @param {string|null|undefined} raw
 * @returns {{ payment_bundle: object|null, payment_methods: object }}
 */
export function parseTransferPaymentFromStorage(raw) {
  const empty = { payment_bundle: null, payment_methods: {} };
  if (raw == null) return empty;
  const s = String(raw).trim();
  if (!s || s === 'Manuel') return empty;
  if (!((s.startsWith('{') && s.endsWith('}')) || (s.startsWith('[') && s.endsWith(']')))) {
    return empty;
  }
  try {
    const o = JSON.parse(s);
    if (!o || typeof o !== 'object' || Array.isArray(o)) return empty;
    if (o.methodId != null) {
      return {
        payment_bundle: {
          methodId: Number(o.methodId),
          amount: o.amount != null ? Number(o.amount) : 0,
          fields: o.fields && typeof o.fields === 'object' ? o.fields : {},
          methodName: o.methodName != null ? String(o.methodName) : '',
        },
        payment_methods: {},
      };
    }
    if (isHotelStylePaymentMethods(o) || Object.keys(o).length > 0) {
      return { payment_bundle: null, payment_methods: o };
    }
  } catch {
    return empty;
  }
  return empty;
}

export function hasConfiguredTransferPayment(draft) {
  const methods = draft?.payment_methods;
  if (methods && typeof methods === 'object' && Object.keys(methods).length > 0) {
    return Object.values(methods).some((v) => {
      if (v == null) return false;
      if (typeof v === 'object' && v.amount !== undefined) return Number(v.amount) > 0;
      return Number(v) > 0;
    });
  }
  const bundle = draft?.payment_bundle;
  return bundle != null && bundle.methodId != null && Number(bundle.amount) > 0;
}

/** Somme des montants saisis (payment_methods ou payment_bundle). */
export function sumTransferPaymentAmount(draft) {
  const methods = draft?.payment_methods;
  if (methods && typeof methods === 'object' && Object.keys(methods).length > 0) {
    return Object.values(methods).reduce((sum, v) => {
      if (v == null) return sum;
      if (typeof v === 'object' && v.amount !== undefined) {
        return sum + (Number(v.amount) || 0);
      }
      return sum + (Number(v) || 0);
    }, 0);
  }
  const bundle = draft?.payment_bundle;
  if (bundle != null && bundle.methodId != null) {
    return Number(bundle.amount) || 0;
  }
  return 0;
}
